import {
  PublicClientApplication,
  type Configuration,
  LogLevel
} from '@azure/msal-browser';

/**
 * Configuration MSAL — flow REDIRECT (recommandé PWA / iOS standalone).
 *
 * Les valeurs sont lues depuis les variables d'env Vite (préfixe VITE_).
 * Voir .env.example pour la liste.
 */
const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_AD_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin
  },
  cache: {
    // sessionStorage est plus sûr (vidé à la fermeture) ; localStorage = SSO entre onglets.
    // En PWA installée, on préfère localStorage pour ne pas forcer une re-auth à chaque coldstart.
    cacheLocation: 'localStorage'
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error)   console.error('[MSAL]', message);
        if (level === LogLevel.Warning) console.warn('[MSAL]', message);
      },
      logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error
    }
  }
};

/** Scope d'API à demander pour appeler le backend ComEasy. */
export const apiScopes: string[] = [
  // Le scope doit matcher celui exposé par l'App Registration de l'API (cf. DEPLOIEMENT.md)
  `api://${import.meta.env.VITE_AZURE_AD_API_CLIENT_ID}/access_as_user`
];

/** Login request : on demande le scope API + les claims standards. */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', ...apiScopes]
};

export const msalInstance = new PublicClientApplication(msalConfig);
